import SignInScreen from "@/pages/SignInScreen";
import { Image } from "lucide-react";

export default function BrandAssets() {
  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-ink text-cream flex items-center justify-center"><Image className="w-5 h-5" /></div>
        <h1 className="font-zilla text-3xl sm:text-4xl font-semibold">Brand Assets</h1>
      </div>
      <p className="text-[17px] text-ink/70 mb-6 max-w-2xl">
        This is where the sign-in screen's appearance and wording are controlled. Membership card
        &amp; certificate templates are managed on the <b>Cards &amp; Certificates</b> page under Settings.
      </p>

      <div className="bg-cream border border-ink/15 rounded-xl p-6 mb-6">
        <h2 className="font-zilla text-xl font-semibold mb-2">Logo &amp; graphics library</h2>
        <p className="text-ink/60 text-[15px]">Primary logo and general graphics uploads — placeholder, coming in a later phase.</p>
      </div>

      <h2 className="font-zilla text-2xl font-semibold mb-3">Sign-In Screen</h2>
      <SignInScreen />
    </div>
  );
}
